import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverGroupSchema } from '../schemas/driver-group.schema';

/**
 * Requests a specific Driver Group
 * @param id The ID of the Driver Group being requested
 * @returns The Driver Group
 */
export function getDriverGroupsId(this: unknown, setId: number) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).driverGroupsUrl
  }/${setId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(driverGroupSchema));
}
